<script>
  import { t } from "../../../../core";
  import axios, { AxiosError } from "axios";
  import FormErrors from "../../../elements/FormErrors.svelte";

  const MAX_LENGTH = 500;

  let isLoading: boolean = false;
  let isSuccess: boolean = false;
  let isDisabled: boolean = false;
  let errorMessage: string = "";
  let isErrorShowing: boolean = false;
  let content: string = "";

  $: isDisabled = content.trim() === "";

  function sendEmail() {
    isLoading = true;
    isSuccess = false;
    isErrorShowing = true;
    errorMessage = "";

    if (content.length > MAX_LENGTH) {
      errorMessage = t("MyProfile.Validation.MaxLength") + " " + MAX_LENGTH;
      isLoading = false;
      return;
    }

    axios
      .post("/api/Customer/changeUserInformation", { content })
      .then(() => {
        isSuccess = true;
        content = "";
      })
      .catch((err: AxiosError) => (errorMessage = err?.response?.data))
      .finally(() => (isLoading = false));
  }
</script>

<label class="send-email__label">
  <textarea
    class="g-input"
    name="emailtext"
    id="emailtext"
    placeholder={t("MyProfile.SendEmail.ContentPlaceholder")}
    rows="6"
    bind:value={content}
  />
</label>

{#if isErrorShowing && errorMessage}
  <FormErrors {errorMessage} />
{/if}

{#if isSuccess}<p>{t("MyProfile.SendEmail.Success")}</p>{/if}

<button
  class="btn send-email__button"
  on:click={sendEmail}
  disabled={isLoading || isDisabled}
>
  {t("MyProfile.SendEmail.SubmitButton")}
</button>

<style lang="scss">
  .send-email {
    &__label {
      margin-bottom: 10px;
    }

    &__button {
      margin-top: 10px;
    }
  }
</style>
